import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import {
    donorPromoCodeCategoryIds,
    partnerReferrers,
    teacherDraftableProjectCategories,
    teacherSupportCategoriesWithPromoCodeInput,
    teacherSupportCategoriesWithResourceInputs,
    teacherSupportCategoriesWithResourceIssueInputs,
    teacherSupportCategoriesWithTYPInput,
} from './contactConstants.js';
import { ContactUs } from './ContactUs.js';
import { Immutable } from '../../external/immutable.js';

/**
 * Higher-order component that manages state for the ContactUs component hierarchy
 */
export const ContactUsState = createReactClass({
    propTypes: {
        data: PropTypes.object.isRequired,
    },

    getInitialState() {
        const initialData = Immutable.fromJS(this.props.data);
        const withSupportCategories = initialData.set('supportCategories', Immutable.Map());
        const withSelectedSupportCategories = withSupportCategories.set('tierSelectedSupportCategories', Immutable.Map());
        const withChosenSupportCategory = withSelectedSupportCategories.set('chosenSupportCategory', Immutable.Map());
        const withFieldsEnabledForEdits = withChosenSupportCategory.set('fieldsEnabledForEdits', []);
        return { map: withFieldsEnabledForEdits };
    },

    componentDidMount() {
        this.setSelectedSupportCategoriesFromParams();
        this.setReferrerValues();
    },

    // invoked on signin from contactUsMain
    signinTriggered() {
        this.setSelectedSupportCategoriesFromParams();
        this.setReferrerValues();
        loader.showPageLoaderAndShield();
        location.replace(this.addRepopulationParams(location.href));
    },

    setSelectedSupportCategoriesFromParams() {
        var tierOneSupportCategoryIdFromUrl = getParameterByName('supportCategory');
        var tierTwoSupportCategoryIdFromUrl = getParameterByName('supportSubCategory');
        var tierThreeSupportCategoryIdFromUrl = getParameterByName('supportIssue');

        // need to update tier selectors synchronously so that all values are set correctly
        var initialTierOneFetchPromise = this.fetchTierOneSupportCategories();
        initialTierOneFetchPromise.then((result) => {
            if (tierOneSupportCategoryIdFromUrl) {
                var event = { target: { value: tierOneSupportCategoryIdFromUrl } };
                var tierOnePromise = this.updateTierOneCategory(event);
                tierOnePromise.then((result) => {
                    if (tierTwoSupportCategoryIdFromUrl) {
                        var event = { target: { value: tierTwoSupportCategoryIdFromUrl } };
                        var tierTwoPromise = this.updateTierTwoCategory(event);
                        tierTwoPromise.then((result) => {
                            if (tierThreeSupportCategoryIdFromUrl) {
                                var event = { target: { value: tierThreeSupportCategoryIdFromUrl } };
                                this.updateTierThreeCategory(event);
                            }
                        });
                    }
                });
            }
        });
    },

    setSupportCategoryTier(data, tierName) {
        this.setState((prevState) => {
            var convertedCategories = Immutable.fromJS(data.supportCategories);
            var updatedSupportCategories = prevState.map.get('supportCategories').set(tierName, convertedCategories);
            var updatedState = prevState.map.set('supportCategories', updatedSupportCategories);
            return { map: updatedState };
        });
    },

    clearSupportCategoryTier(tierName) {
        this.setState((prevState) => {
            var updatedSupportCategories = prevState.map.get('supportCategories').set(tierName, []);
            var updatedState = prevState.map.set('supportCategories', updatedSupportCategories);
            return { map: updatedState };
        });
    },

    fetchTierOneSupportCategories() {
        return $.ajax({
            type: 'GET',
            url: secureBaseURL + '/help/support_categories.html',
            data: { formType: this.state.map.get('formType') },
        }).done((data) => {
            this.setSupportCategoryTier(data, 'tierOneSupportCategories');
        }).fail(function (data) {
            alert('Error retrieving support categories, please try again.');
        });
    },

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState((prevState) => {
            var updatedForm = prevState.map.get('formData').set(name, value);
            var updatedState = prevState.map.set('formData', updatedForm);

            return { map: updatedState };
        });
    },

    clearResourceIdsFormField() {
        this.setState((prevState) => {
            var updatedForm = prevState.map.get('formData').set('resourceIds', Immutable.Map());
            var updatedState = prevState.map.set('formData', updatedForm);

            return { map: updatedState };
        });
    },

    addGiftCode() {
        this.setState((prevState) => {
            const giftCodeList = prevState.map.get('formData').get('giftCodes');
            const numGiftCodes = giftCodeList.size;
            const giftCodeListWithAddition = giftCodeList.set(numGiftCodes, '');
            const formDataWithAddition = prevState.map.get('formData').set('giftCodes', giftCodeListWithAddition);
            const stateObjectWithAddition = prevState.map.set('formData', formDataWithAddition);
            return { map: stateObjectWithAddition };
        });
    },

    removeGiftCode(event) {
        const giftCodeTextboxId = event.target.id;
        const giftCodeIndex = this.parseIndexFromArrayString(giftCodeTextboxId);
        this.setState((prevState) => {
            const giftCodeList = prevState.map.get('formData').get('giftCodes');
            const giftCodeListWithDeletion = giftCodeList.delete(giftCodeIndex);
            const formDataWithDeletion = prevState.map.get('formData').set('giftCodes', giftCodeListWithDeletion);
            const stateObjectWithDeletion = prevState.map.set('formData', formDataWithDeletion);
            return { map: stateObjectWithDeletion };
        });
    },

    handleGiftCodesChange(event) {
        this.handleListInputChange(event, 'giftCodes');
    },

    handleDonorEmailAddressesChange(event) {
        this.handleListInputChange(event, 'donorEmailAddresses');
    },

    handleResourceSelectionChange(event) {
        this.handleListInputChange(event, 'resourceIds');
    },

    /**
     * Supports lists of inputs with IDs in the form: name[index].  e.g. addresses[0], addresses[1], etc.
     * Maps to an array in the formData map.  e.g. formData.addresses.length == 2
     * @param event
     * @param key The prefix used in the input IDs
     */
    handleListInputChange(event, key) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const id = target.id;
        const index = this.parseIndexFromArrayString(id);

        this.setState((prevState) => {
            var updatedKeyValue = prevState.map.get('formData').get(key).set(index, value);
            var updatedForm = prevState.map.get('formData').set(key, updatedKeyValue);
            var updatedState = prevState.map.set('formData', updatedForm);

            return { map: updatedState };
        });
    },

    handleAutoResourceSelectionChange(id, value) {
        const index = this.parseIndexFromArrayString(id);

        this.setState((prevState) => {
            var updatedKeyValue = prevState.map.get('formData').get('resourceIds').set(index, value);
            var updatedForm = prevState.map.get('formData').set('resourceIds', updatedKeyValue);
            var updatedState = prevState.map.set('formData', updatedForm);

            return { map: updatedState };
        });
    },

    parseIndexFromArrayString(arrayString) {
        return parseInt(arrayString.substring(arrayString.lastIndexOf('[') + 1, arrayString.lastIndexOf(']')));
    },

    handlePartnerReferrerChange(event) {
        const value = event.target.value;

        var wordOfMouthReferrer;
        if (value !== 'Other') {
            wordOfMouthReferrer = value;
        } else {
            wordOfMouthReferrer = null;
        }

        this.setState((prevState) => {
            var withUpdatedPartnerReferrer = prevState.map.get('formData').set('partnerReferrer', value);
            var updatedForm = withUpdatedPartnerReferrer.set('wordOfMouthReferrer', wordOfMouthReferrer);
            var updatedState = prevState.map.set('formData', updatedForm);

            return { map: updatedState };
        });
    },

    setReferrerValues() {
        var value = this.props.data.formData.wordOfMouthReferrer;
        if (value) {
            var partnerReferrer;
            if (partnerReferrers.indexOf(value) > -1) {
                partnerReferrer = value;
            } else {
                partnerReferrer = 'Other';
            }

            this.setState((prevState) => {
                var withUpdatedPartnerReferrer = prevState.map.get('formData').set('partnerReferrer', partnerReferrer);
                var updatedForm = withUpdatedPartnerReferrer.set('wordOfMouthReferrer', value);
                var updatedState = prevState.map.set('formData', updatedForm);

                return { map: updatedState };
            });
        }
    },

    handleFormSubmit(event) {
        event.target.action = this.addRepopulationParams(event.target.action);
        if (this.state.map.get('chosenSupportCategory')) {
            dcAnalytics.trackEventGA(['Donor contact form', this.state.map.get('chosenSupportCategory').get('keyword'), 'Submit']);
        }
        loader.showPageLoaderAndShield();
    },

    isValidSupportCategoryId(supportCategoryId, tierName){
        return this.state.map.get('supportCategories').get(tierName).find(el => el.get('id') == supportCategoryId) !== undefined;
    },

    setTierSelectedSupportCategory(supportCategoryId, tierName) {
        this.setState((prevState) => {
            var updatedSelectedSupportCategories = prevState.map.get('tierSelectedSupportCategories').set(tierName, supportCategoryId);
            var updatedState = prevState.map.set('tierSelectedSupportCategories', updatedSelectedSupportCategories);
            return { map: updatedState };
        });
    },

    setChosenSupportCategory(supportCategoryId, tierName) {
        this.setState((prevState) => {
            var chosenSupportCategory = prevState.map.get('supportCategories').get(tierName).filter(el => el.get('id') == supportCategoryId).first();
            var withUpdatedChosenSupportCategory = prevState.map.set('chosenSupportCategory', chosenSupportCategory);
            var updatedForm = prevState.map.get('formData').set('supportCategoryId', supportCategoryId);
            var updatedState = withUpdatedChosenSupportCategory.set('formData', updatedForm);
            return { map: updatedState };
        }, () => {
            this.filterProjects();
        });
    },

    clearChosenSupportCategory() {
        this.setState((prevState) => {
            var withUpdatedChosenSupportCategory = prevState.map.set('chosenSupportCategory', Immutable.Map());
            var updatedForm = prevState.map.get('formData').set('supportCategoryId', null);
            var updatedState = withUpdatedChosenSupportCategory.set('formData', updatedForm);
            return { map: updatedState };
        });
    },

    enablePrepopulatedFieldEdit(event) {
        var fieldName = event.currentTarget.name;
        this.setState((prevState) => {
            var fieldsEnabledForEdits = prevState.map.get('fieldsEnabledForEdits');
            if (fieldsEnabledForEdits.indexOf(fieldName) === -1) {
                fieldsEnabledForEdits.push(fieldName);
                var updatedState = prevState.map.set('fieldsEnabledForEdits', fieldsEnabledForEdits);
                return { map: updatedState };
            }
        });
    },

    getSupportSubCategoryPromise(supportCategoryId) {
        return $.ajax({
            url: '/help/support_categories.html',
            dataType: 'json',
            data: { supportCategoryId: supportCategoryId },
        }).fail(function (data) {
            alert('Error retrieving support categories, please try again.');
        });
    },

    updateTierOneCategory(event) {
        return new Promise((resolve, reject) => {
            const supportCategoryId = event.target.value;

            if (!isNaN(supportCategoryId) && this.isValidSupportCategoryId(supportCategoryId, 'tierOneSupportCategories')) {
                this.setTierSelectedSupportCategory(supportCategoryId, 'tierOneSelectedCategory');
                this.setTierSelectedSupportCategory(null, 'tierTwoSelectedCategory');
                this.setTierSelectedSupportCategory(null, 'tierThreeSelectedCategory');
                this.clearSupportCategoryTier('tierThreeSupportCategories');

                this.getSubCategories(resolve, supportCategoryId, 'tierOneSupportCategories', 'tierTwoSupportCategories');
            }
        });
    },

    updateTierTwoCategory(event) {
        return new Promise((resolve, reject) => {
            const supportCategoryId = event.target.value;

            if (!isNaN(supportCategoryId) && this.isValidSupportCategoryId(supportCategoryId, 'tierTwoSupportCategories')) {
                this.setTierSelectedSupportCategory(supportCategoryId, 'tierTwoSelectedCategory');
                this.setTierSelectedSupportCategory(null, 'tierThreeSelectedCategory');

                this.getSubCategories(resolve, supportCategoryId, 'tierTwoSupportCategories', 'tierThreeSupportCategories');
            }
        });
    },

    getSubCategories(resolve, supportCategoryId, currentTier, nextTier) {
        var supportSubCategoryPromise = this.getSupportSubCategoryPromise(supportCategoryId);
        supportSubCategoryPromise.done((data) => {
            var supportSubCategoriesArray = data.supportCategories;
            if (supportSubCategoriesArray.length > 0) {
                this.clearChosenSupportCategory();
                if (supportCategoryId == donorPromoCodeCategoryIds['promo-codes']) {
                    this.checkRemoveForgotPromoCodeOption(supportSubCategoriesArray);
                }
                this.setSupportCategoryTier(data, nextTier);
            } else {
                this.setChosenSupportCategory(supportCategoryId, currentTier);
                this.clearSupportCategoryTier(nextTier);
            }
            resolve();
        });
    },

    updateTierThreeCategory(event) {
        const supportCategoryId = event.target.value;

        if (!isNaN(supportCategoryId) && this.isValidSupportCategoryId(supportCategoryId, 'tierThreeSupportCategories')) {
            this.setTierSelectedSupportCategory(supportCategoryId, 'tierThreeSelectedCategory');
            this.setChosenSupportCategory(supportCategoryId, 'tierThreeSupportCategories');
        }
    },

    // retrieve selectable projects based on the keyword of the chosen support category
    filterProjects() {
        var keyword = this.state.map.get('chosenSupportCategory').get('keyword');
        var loadingProjects = false;
        if (this.state.map.get('loggedInUser') && keyword) {
            if (teacherSupportCategoriesWithTYPInput[keyword] > -1) {
                loadingProjects = true;
                this.getProjectsByWorkflowStatuses('/common/wfs/typ_extension.html');
            } else if (teacherSupportCategoriesWithPromoCodeInput[keyword] > -1) {
                loadingProjects = true;
                this.getProjects('/common/projects/teacher_submitted_projects.html');
            } else if (teacherSupportCategoriesWithResourceInputs[keyword] > -1) {
                const purchasedMaterialStatusesOnly = teacherSupportCategoriesWithResourceIssueInputs[keyword] > -1;
                loadingProjects = true;
                this.getProjectsByWorkflowStatuses('/common/wfs/materials_support.html?purchasedMaterialStatusesOnly=' + purchasedMaterialStatusesOnly);
            } else if (teacherDraftableProjectCategories[keyword] > -1) {
                loadingProjects = true;
                this.getProjects('/common/projects/teacher_draftable_projects.json');
            }
        }
        if (loadingProjects) {
            this.setLoadingProjects(true);
        } else {
            this.setState((prevState) => {
                var updatedState = prevState.map.set('filteredProjects', null);
                return { map: updatedState };
            });
        }
    },

    setFilteredProjects(projectsData) {
        this.setLoadingProjects(false);
        this.showAllProjects(false);
        this.setState((prevState) => {
            var updatedState = prevState.map.set('filteredProjects', projectsData);
            return { map: updatedState };
        });
    },

    setLoadingProjects(projectsAreLoading) {
        this.setState((prevState) => {
            var updatedState = prevState.map.set('loadingProjects', projectsAreLoading);
            return { map: updatedState };
        });
    },

    getProjectsByWorkflowStatuses(wfsUrl) {
        var projectsUrl = '/common/projects/projects_in_wfs_list_for_teacher.html';
        var component = this;
        $.ajax({
            url: wfsUrl,
        }).done(function (data) {
            component.getProjects(projectsUrl, $.parseJSON(data));
        });
    },

    getProjects(url, workflowStatuses) {
        var workflowStatuses = (typeof workflowStatuses === 'undefined') ? null : workflowStatuses;
        var userId = this.state.map.get('formData').get('userId');
        var component = this;
        $.ajax({
            url: url,
            data: $.param({ teacherId: userId, workflowStatusId: workflowStatuses }, true),
        }).done(function (data) {
            var projectsData = typeof data === 'object' ? data : $.parseJSON(data);
            component.setFilteredProjects(projectsData);
        });
    },

    showAllProjects(value) {
        this.setState((prevState) => {
            var updatedState = prevState.map.set('showAllProjects', value);
            return { map: updatedState };
        });
    },

    checkRemoveForgotPromoCodeOption(supportCateogries) {
        if (!this.state.map.get('donationInfo') || this.state.map.get('donationInfo').length === 0) {
            for (var i = 0; i < supportCateogries.length; i++) {
                if (supportCateogries[i].id == donorPromoCodeCategoryIds['forgot-promo-code']) {
                    supportCateogries.splice(i, 1);
                }
            }
        }
    },

    addRepopulationParams(action) {
        var tierOneSelectedCategoryId = this.state.map.get('tierSelectedSupportCategories').get('tierOneSelectedCategory');
        var tierTwoSelectedCategoryId = this.state.map.get('tierSelectedSupportCategories').get('tierTwoSelectedCategory');
        var tierThreeSelectedCategoryId = this.state.map.get('tierSelectedSupportCategories').get('tierThreeSelectedCategory');

        // TODO update contact links (and admin site?) to use "tier" names instead of category/subcategory/issue
        if (tierOneSelectedCategoryId) {
            action = setURLParam(action, 'supportCategory', tierOneSelectedCategoryId);
        }

        if (tierTwoSelectedCategoryId) {
            action = setURLParam(action, 'supportSubCategory', tierTwoSelectedCategoryId);
        }

        if (tierThreeSelectedCategoryId) {
            action = setURLParam(action, 'supportIssue', tierThreeSelectedCategoryId);
        }
        return action;
    },

    findUserByUserName(event) {
        var json = '/common/json-check-existing-user.html?autoSendSigninLink=true&username=' + event.target.value + '&go=' + encodeURIComponent(location.href);

        $.getJSON(json, function (obj) {
            if (obj != null && obj.data != null && obj.data.user != null) {
                window.signinStatusForTracking = 'recognised user';

                toggleContactFormSignInOverlay(true, obj.data);
            }
        });
    },

    render() {
        var data = this.state.map.toJS();
        var callbacks = {
            findUserByUserName: this.findUserByUserName,
            handleInputChange: this.handleInputChange,
            handleDonorEmailAddressesChange: this.handleDonorEmailAddressesChange,

            // gift code list for teacher/donor use cases w/ expired gift codes
            handleGiftCodesChange: this.handleGiftCodesChange,
            addGiftCodeCallback: this.addGiftCode,
            removeGiftCodeCallback: this.removeGiftCode,

            handlePartnerReferrerChange: this.handlePartnerReferrerChange,
            handleFormSubmit: this.handleFormSubmit,
            enablePrepopulatedFieldEdit: this.enablePrepopulatedFieldEdit,
            updateTierOneCategory: this.updateTierOneCategory,
            updateTierTwoCategory: this.updateTierTwoCategory,
            updateTierThreeCategory: this.updateTierThreeCategory,
            getProjects: this.getProjects,
            showAllProjects: this.showAllProjects,
            handleResourceSelectionChange: this.handleResourceSelectionChange,
            handleAutoResourceSelectionChange: this.handleAutoResourceSelectionChange,
            clearResourceIdsFormField: this.clearResourceIdsFormField,
        };

        return (
            <ContactUs data={data} callbacks={callbacks}/>
        );
    },
});
